import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetFeatureFlagsQuery } from '../../../../api/features';
import { VERIFY_REVENUE } from '../../../../paths';
import { DocumentCollectionPage } from '../../../document-collection/pages/document-collection-page';

const VerifyDocumentsUploadPage: FC = () => {
  const { data: featureFlags } = useGetFeatureFlagsQuery();
  const navigate = useNavigate();
  const handleBack = useCallback(() => {
    navigate(VERIFY_REVENUE);
  }, [navigate]);

  return (
    <DocumentCollectionPage
      pdfOnly={true}
      nextAction="verify_revenue"
      onBack={featureFlags?.enableLinkBankAccount ? handleBack : undefined}
      portalType={'apply'}
    />
  );
};

export { VerifyDocumentsUploadPage };
